import { SalesData as ApiSalesData } from "randmar-api-client";
import React from "react";
import { FormattedNumber } from 'react-intl';
import { Card } from "randmarcomps";
import { LongMonthName } from '../../components/util/DateTimeUtil';
import SalesTrendingIcon from '../../components/util/SalesTrendingIcon';
import { SalesData as LegacySalesData } from '../../stores/manufacturer/Manufacturer';

interface IProps {
  fiscalYearMonthStart?: number;
  salesData?: LegacySalesData | ApiSalesData;
  isQualified?: boolean;
}

const StatDisplay: React.FC<{ title: string; value?: number; subTitle?: string }> = ({ title, subTitle, value }) => (
  <div>
    <p className="text-sm font-medium text-gray-500">{title}{subTitle && ` (${subTitle})`}</p>
    <p className="text-4xl font-bold tracking-tight text-gray-800"><FormattedNumber value={value || 0} /></p>
  </div>
);

const SalesSummary: React.FC<IProps> = ({ salesData: rawSalesData, fiscalYearMonthStart, isQualified }) => {
  const isLegacy = (sd: LegacySalesData | ApiSalesData | undefined): sd is LegacySalesData => !!sd && 'salesLast30Days' in sd;

  const salesData: ApiSalesData | undefined = isLegacy(rawSalesData)
    ? {
      SalesLast30Days: rawSalesData.salesLast30Days,
      SalesLast3Months: rawSalesData.salesLast3Months,
      SalesYearToDay: rawSalesData.salesYearToDay,
    }
    : rawSalesData;
  const cardClasses = `bg-white ${isQualified ? "border-2 border-indigo-600 shadow-lg" : "border"}`;

  return (
    <Card className={cardClasses}>
      <div className="flex flex-col divide-y md:flex-row md:divide-x md:divide-y-0" title="Sales">
        {(fiscalYearMonthStart || 0) > 0 && (
          <div className="flex-1 p-5 text-center">
            <StatDisplay title="Year to Day" subTitle={LongMonthName(fiscalYearMonthStart)} value={salesData?.SalesYearToDay} />
          </div>
        )}
        <div className="flex-1 p-5 text-center">
          <StatDisplay title="Last 3 Months" value={salesData?.SalesLast3Months} />
        </div>
        <div className="flex-1 p-5 text-center">
          <StatDisplay title="Last 30 days" value={salesData?.SalesLast30Days} />
        </div>
        <div className="flex-1 p-5 flex items-center justify-center">
          <SalesTrendingIcon salesData={salesData} fontSize="large" />
        </div>
      </div>
    </Card>
  );
}

export default SalesSummary;
